import { useState, useCallback } from 'react';
import useApi from '../useApi';
import axiosInstance from '../axiosInstance';

export const useGetHeaderConfig = (options = {}) => {
  return useApi('/cms/layout/header-config', {
    method: 'GET',
    ...options,
  });
};

export const useUpdateHeaderConfig = (options = {}) => {
  return useApi('/cms/layout/header-config', {
    method: 'PUT',
    ...options,
  });
};

export const useUploadHeaderLogo = () => {
  const [logoUrl, setLogoUrl] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const uploadLogo = useCallback(async (file) => {
    setLoading(true);
    setError(null);
    try {
      const formData = new FormData();
      formData.append('logo', file);
      const { data } = await axiosInstance.post('/cms/layout/header-config/logo', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      const url = data?.data?.logoUrl ?? null;
      setLogoUrl(url);
      return url;
    } catch (err) {
      const msg = err.response?.data?.message || 'Failed to upload logo';
      setError(msg);
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  return { logoUrl, loading, error, uploadLogo };
};